interface ClockSelf { employeeId?: string | null; authUser?: { organization_id?: string | number | null; role?: string | null; is_admin?: boolean; chatbot_mode?: string | null } | null }

/** A cache identity is not the employee ID used to own offline punches. */
export function clockReadScope(self: ClockSelf | undefined) {
  const org = self?.authUser?.organization_id
  return self?.employeeId && org ? `${self.employeeId}:${org}:${self.authUser?.role || ''}` : ''
}

/** File delivery also belongs to the selected access view; never changes offline ownership. */
export function clockDownloadScope(self: ClockSelf | undefined) {
  const readScope = clockReadScope(self)
  return readScope && self?.authUser?.role ? JSON.stringify([readScope, !!self.authUser.is_admin, self.authUser.chatbot_mode ?? 'user']) : ''
}
